export const MATERIAL_TRANSLATE_ALGO_ZH_STATUS = {
  FAILURE: 'failure',
  IN_PROCESS: 'in_process',
  SUCCESS: 'success',
} as const

export type MaterialTranslateAlgoZhStatusValue =
  | ''
  | (typeof MATERIAL_TRANSLATE_ALGO_ZH_STATUS)[keyof typeof MATERIAL_TRANSLATE_ALGO_ZH_STATUS]

export interface MaterialTranslateAlgoZhParams {
  /** SR 素材主键之一。新版素材不再使用 MySQL 数值 id，因此这里统一传字符串主键。 */
  materialId: string
  /** SR 素材主键之一。与 materialId 一起定位同一条 dwd 素材记录。 */
  mediaPlatform: string
  prompt?: string
}

interface MaterialTranslateAlgoZhStatusData {
  algoAnalysisZhRequestId?: string
  algoAnalysisZhResult?: null | Record<string, unknown>
  algoAnalysisZhStatus?: MaterialTranslateAlgoZhStatusValue | string
}

interface MaterialTranslateAlgoZhStatusResponse {
  code?: number
  cost?: string
  data?: MaterialTranslateAlgoZhStatusData | null
  msg?: string
  traceID?: string
}

export interface MaterialTranslateAlgoZhStatusResult {
  algoAnalysisZhRequestId: string
  algoAnalysisZhResult: null | Record<string, unknown>
  algoAnalysisZhStatus: MaterialTranslateAlgoZhStatusValue | string
  msg: string
}

export const normalizeMaterialTranslateAlgoZhStatusResponse = (
  response:
    | MaterialTranslateAlgoZhStatusData
    | MaterialTranslateAlgoZhStatusResponse
    | null
    | undefined,
): MaterialTranslateAlgoZhStatusResult => {
  const data =
    response &&
    typeof response === 'object' &&
    'data' in response &&
    response.data
      ? response.data
      : response

  const payload =
    data && typeof data === 'object'
      ? (data as MaterialTranslateAlgoZhStatusData)
      : undefined

  return {
    algoAnalysisZhRequestId: payload?.algoAnalysisZhRequestId?.trim?.() || '',
    algoAnalysisZhResult:
      payload?.algoAnalysisZhResult &&
      typeof payload.algoAnalysisZhResult === 'object'
        ? payload.algoAnalysisZhResult
        : null,
    algoAnalysisZhStatus: payload?.algoAnalysisZhStatus || '',
    msg:
      response &&
      typeof response === 'object' &&
      'msg' in response &&
      typeof response.msg === 'string'
        ? response.msg.trim()
        : '',
  }
}
